import { useTranslate } from "@made-people/grease-translations";
import { overlayEventEmitter } from "@made-people/blueprint-overlay";
import { useGreaseGrowthbookFeatureValue } from "@made-people/grease-growthbook";

export const CustomisationBanner = () => {
  const translate = useTranslate();
  const customisationModalEnabled = useGreaseGrowthbookFeatureValue(
    "comfort-suite:customisation-modal",
    false,
  );

  if (typeof customisationModalEnabled === "undefined") {
    return null;
  }

  if (!customisationModalEnabled) {
    return null;
  }

  return (
    <div className="my-6 lg:mt-0 flex flex-col gap-3 rounded-md bg-[#E6F1F7] px-6 py-4 text-left max-w-[416px]">
      <p className="text-body-sm">{translate("Customisation_Banner_Active")}</p>
      <button
        className="text-body-sm underline underline-offset-2 text-left"
        onClick={() =>
          overlayEventEmitter.emit("open", {
            overlayId: "comfort-suite-customisation",
          })
        }
      >
        {translate("Customisation_Banner_Button")}
      </button>
    </div>
  );
};
